import type { JSX } from "react";
import type { CrudOperation } from "../../crud-operation/crud-operation";
import { useObservable } from "ecce-react";
import { useServices } from "../../services/services-context";
import { useLatch } from "../../util/use-latch";
import { Form } from "../atoms/form";
import { PanelDialog } from "../molecules/dialog-panel";


const FORM_ID = "crudOpForm";
const ActiveOperationDialog = (p: { activeOperation: CrudOperation<unknown>; }) => {
	const { crud } = useServices();
	useObservable(crud, "loading");

	useObservable(p.activeOperation, "showActions");

	return (
		<PanelDialog
			title={ p.activeOperation.title }
			headerContent={ p.activeOperation.panelHeaderContent }
			open={ !!crud.activeOperation }
			loading={ crud.loading }
			onClose={ () => crud.cancel(false) }
			dismissible
			primaryAction={ p.activeOperation.showActions ? {
				label: p.activeOperation.submitLabel,
				color: p.activeOperation.submitLabelColor,
				submitFormId: FORM_ID,
			} : null }
			secondaryAction={ p.activeOperation.showActions
				? p.activeOperation.secondaryAction
				: null
			}
			fullHeight={ p.activeOperation["fullHightDialog"] }
		>
			<Form id={ FORM_ID } onSubmit={ crud.submit } style={{ minHeight: 64 }}>
				<p.activeOperation.view/>
			</Form>
		</PanelDialog>
	);
};

export const CrudDialog = (): JSX.Element | null => {
	const { crud } = useServices();
	useObservable(crud, "activeOperation");

	const activeOperation = useLatch(crud.activeOperation);

	if(!activeOperation) {
		return null;
	}

	return (
		<ActiveOperationDialog activeOperation={ activeOperation }/>
	);
};
